import React, { useEffect, useState } from 'react';
import { injectIntl } from "react-intl";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import { useHistory } from 'react-router-dom';
import './style.scss';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/labTests/actions';
import { getReferenceLabsListRequest } from '../../store/referenceLabs/actions';
import { arabicConvertor, englishConvertor } from '../../utils/Shared';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';

function LabForm({ intl: { messages }, lab }) {
    const history = useHistory();
    const dispatch = useDispatch();
    const { referenceLabsList } = useSelector((state) => state?.referenceLabs);
    const [cancelConfirmation, setCancelConfirmation] = useState(false);
    const [referenceLabs, setReferenceLabs] = useState([]);
    const [feedback, setFeedback] = useState('');
    const user = useSelector((state) => state.auth?.user?.data);

    useEffect(() => {
        dispatch(getReferenceLabsListRequest());
      }, [dispatch]);
    
      useEffect(() => {
        if (referenceLabsList && referenceLabsList.length > 0) {
          let list = [];
          referenceLabsList.forEach((item) => {
            list.push({
              id: item.id,
              name: item.name.en,
            });
          });
          setReferenceLabs(list);
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [referenceLabsList]);

    const tubesList = [
        {
            id: 1,
            name: 'EDTA',
        },
        {
            id: 2,
            name: 'Heparin Tube',
        },
        {
            id: 3,
            name: 'Plasma',
        }
    ];

    const relatedList = [
        { id: 1, name: messages.labTests.form.option1 },
        { id: 2, name: messages.labTests.form.option2 },
        { id: 3, name: messages.labTests.form.option3 },
    ];

    const shippingCompanies = [
        {id: 1 , name: messages.labTests.form.company1},
        {id: 2 , name: messages.labTests.form.company2},
        {id: 3 , name: messages.labTests.form.company3},
    ];

    const shippingLocations = [
        {id: 1 , name: messages.labTests.form.location1},
        {id: 2 , name: messages.labTests.form.location2},
        {id: 3 , name: messages.labTests.form.location3},
    ]

    const [formData, setFormData] = useState({
        id: null,
        code: '',
        tube_type: 0,
        tubes_count: 2,
        name: {
            en: '',
            ar: ''
        },
        sample_type: {
            en: "Blood Sample",
            ar: "عينة دم",
        },
        sample_quantity: messages.labTests.form.ammount_placeholder,
        price: '',
        price_after_discount: '',
        reference_lab_id: 0,
        obligation_type: 0,
        result_due_days: 0,
        lab_test_shipping_locations: [{
            shipping_company: 0,
            from: 0,
            to: 0,
        }],
    });

    const clear = () => {
        setFormData({
            id: null,
            code: '',
            tube_type: 0,
            tubes_count: 2,
            name: {
                en: '',
                ar: ''
            },
            sample_type: {
                en: "Blood Sample",
                ar: "عينة دم",
            },
            sample_quantity: messages.labTests.form.ammount_placeholder,
            price: '',
            price_after_discount: '',
            reference_lab_id: 0,
            obligation_type: 0,
            result_due_days: 0,
            lab_test_shipping_locations: [{
                shipping_company: 0,
                from: 0,
                to: 0,
            }],
        });
        document.getElementById('code').style.borderColor = '#eee';
        document.getElementById('enname').style.borderColor = '#eee';
        document.getElementById('arname').style.borderColor = '#eee';
        document.getElementById('reflab').style.borderColor = '#eee';
        document.getElementById('bloodEn').style.borderColor = '#eee';
        document.getElementById('bloodAr').style.borderColor = '#eee';
        document.getElementById('ammount').style.borderColor = '#eee';
        document.getElementById('tubetype').style.borderColor = '#eee';
        document.getElementById('tubeNumber').style.borderColor = '#eee';
        document.getElementById('priceBefore').style.borderColor = '#eee';
        document.getElementById('priceAfter').style.borderColor = '#eee';
        document.getElementById('shipping_company').style.borderColor = '#eee';
        document.getElementById('relatedTest').style.borderColor = '#eee';

    }

    useEffect(() => {
        if (lab) {
            setFormData({
                id: lab.id,
                code: lab.code,
                tube_type: lab.tube_type,
                tubes_count: lab.tubes_count,
                name: {
                    en: lab.name?.en,
                    ar: lab.name?.ar,
                },
                sample_type: {
                    en: lab.sample_type?.en,
                    ar: lab.sample_type?.ar,
                },
                sample_quantity: lab.sample_quantity,
                price: lab.price,
                price_after_discount: lab.price_after_discount,
                reference_lab_id: lab.reference_lab?.id,
                obligation_type: lab.obligation_type,
               //shipping_company: lab.shipping_company,
                result_due_days: lab.result_due_days,
                lab_test_shipping_locations: lab.lab_test_shipping_locations,
            });
        }
    }, [lab]);

    // Validation
    const validation = () => {
        let isValid = true;

        if (!formData.result_due_days || formData.result_due_days === 0) {
            document.getElementById('result_due_days').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.labTests.result_due_days_error);
        }
        if (formData.price_after_discount > formData.price) {
            document.getElementById('priceAfter').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.labTests.form.price_error);
        }  
        if (formData.price_after_discount === '') {
            document.getElementById('priceAfter').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.labTests.form.price_invalid);
        }
        if (formData.price === '') {
            document.getElementById('priceBefore').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.labTests.form.price_invalid);
        }
        if (formData.obligation_type === 0) {
            document.getElementById('relatedTest').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.labTests.form.obligation_type_error);
        }
        if (formData.tubes_count === '') {
            document.getElementById('tubeNumber').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.labTests.form.tube_number_error);
        }
        if (formData.tube_type === 0) {
            document.getElementById('tubetype').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.labTests.form.tube_type_error);
        }
        if (formData.sample_quantity === '') {
            document.getElementById('ammount').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.labTests.form.ammount_error);
        }
        if (formData.sample_type === '') {
            document.getElementById('bloodEn').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.labTests.form.blood_error);
        }
        if (formData.sample_type === '') {
            document.getElementById('bloodAr').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.labTests.form.blood_error);
        }
        if (formData.reference_lab_id === 0) {
            document.getElementById('reflab').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.labTests.form.ref_lab_error);
        }
        if (formData.name.en === '') {
            document.getElementById('enname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.labTests.form.en_name_invalid);
        }
        if (formData.name.ar === '') {
            document.getElementById('arname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.labTests.form.ar_name_invalid);
        }
        if (formData.code === '') {
            document.getElementById('code').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.labTests.form.code_placeholder);
        }

        if (formData.price_after_discount === '' && formData.price === '' && formData.tube_type === 0 && formData.reference_lab_id === 0 && formData.name.en === '' && formData.name.ar === '' && formData.code === '') {
            setFeedback(messages.labTests.form.allRequired);
        }
       
        return isValid;
    }

    // Save Function
    const handleSave = (e) => {
        e.preventDefault()
        if (validation()) {
            setFeedback('');
            if (lab) {
                dispatch(actions.editLabTestRequest(formData, history));
            } else {
                dispatch(actions.addLabTestRequest(formData, history));
            }
        }
    }

    // Cancel Function
    const handleCancel = (e) => {
        e.preventDefault();
        if (lab) {
            if (formData.code === lab.code && formData.name.en === lab.name.en && formData.name.ar === lab.name.ar && formData.sample_type.en === lab.sample_type.en && formData.sample_type.ar === lab.sample_type.ar && formData.sample_quantity === lab.sample_quantity && formData.price === lab.price && formData.price_after_discount === lab.price_after_discount && formData.tube_type === lab.tube_type && formData.tubes_count === lab.tubes_count && formData.reference_lab_id === lab.reference_lab.id) {
                history.push(`/lab-tests`);
            } else {
                setCancelConfirmation(true);
            }
        } else {
            if (formData.code === '' && formData.name.en === '' && formData.name.ar === '' && formData.price === '' && formData.price_after_discount === '' && formData.tube_type === 0 && formData.reference_lab_id === 0) {
                history.push(`/lab-tests`);
            } else {
                setCancelConfirmation(true);
            }
        }
    }

    //console.log(formData);

    return (
        <div className='userform_container'>
            <form>
                <h3>{messages.labTests.form.title}</h3>
                <div className="row">
                    <div className="col-md-4">
                        <label htmlFor="code" className='required'>{messages.labTests.form.code}</label>
                        <input type="text" name="code" id="code" autoFocus={true}
                                placeholder={messages.labTests.form.code_placeholder}
                                value={formData.code}
                                onChange={e => {
                                    //const re = /^[A-Za-z]+$/;
                                    //if (e.target.value === "" || re.test(e.target.value)) {
                                        document.getElementById('code').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, code: e.target.value })
                                    //}
                                }}
                                disabled={user?.role_id === 1 ? false : true} 
                                />
                    </div>
                    <div className="col-md-4" id='arname_container'>
                        <label htmlFor="arname" className='required'>{messages.labTests.form.ar_name}</label>
                        <input type="text" name="arname" id="arname"
                                placeholder={messages.labTests.form.ar_name_placeholder}
                                value={formData.name.ar}
                                onChange={e => {
                                    document.getElementById('arname').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, name: { ...formData.name, ar: arabicConvertor(e.target.value) } })
                                    }}
                                disabled={user?.role_id === 1 ? false : true}    
                                />
                    </div>
                    <div className="col-md-4" id='enname_container'>
                        <label htmlFor="enname" className='required'>{messages.labTests.form.en_name}</label>
                        <input type="text" name="enname" id="enname"
                                placeholder={messages.labTests.form.en_name_placeholder}
                                value={formData.name.en} 
                                onChange={e => {
                                    document.getElementById('enname').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, name: { ...formData.name, en: englishConvertor(e.target.value) } })
                                }}
                                disabled={user?.role_id === 1 ? false : true}
                                />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <label htmlFor="reflab" className='required'>{messages.labTests.form.ref_labs}</label>
                        <select name="reflab" id="reflab"
                                value={formData.reference_lab_id}
                                onChange={e => {
                                    document.getElementById('reflab').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, reference_lab_id: e.target.value })
                                }}
                                disabled={user?.role_id === 1 ? false : true}
                                >
                            <option value={0}>{messages.labTests.form.ref_labs_placeholder}</option>
                            {referenceLabs?.map(ref => <option key={ref.id} value={ref.id}>{ref.name}</option>)}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="bloodAr" className='required'>{messages.labTests.form.blood_ar}</label>
                        <input type="bloodAr" name="bloodAr" id="bloodAr"
                            placeholder={messages.labTests.form.blood_ar_placeholder}
                            value={formData.sample_type?.ar}
                            onChange={e => {
                                document.getElementById('bloodAr').style.borderColor = '#eee';
                                setFeedback('');
                                setFormData({ ...formData, sample_type: { ...formData.sample_type, ar: e.target.value } })
                            }}
                            disabled={user?.role_id === 1 ? false : true}
                            />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="bloodEn" className='required'>{messages.labTests.form.blood}</label>
                        <input type="bloodEn" name="bloodEn" id="bloodEn"
                            placeholder={messages.labTests.form.blood_placeholder}
                            value={formData.sample_type?.en}
                            onChange={e => {
                                document.getElementById('bloodEn').style.borderColor = '#eee';
                                setFeedback('');
                                setFormData({ ...formData, sample_type: { ...formData.sample_type, en: e.target.value } })
                            }}
                            disabled={user?.role_id === 1 ? false : true}
                            />
                        
                    </div>
                </div>
                <div className='row' >
                    <div className="col-md-4">
                        <label htmlFor="ammount" className='required'>{messages.labTests.form.ammount}</label>
                        <input type="ammount" name="ammount" id="ammount"
                                value={formData.sample_quantity}
                                onChange={e => {
                                    document.getElementById('ammount').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, sample_quantity: e.target.value })
                                }}
                                disabled={user?.role_id === 1 ? false : true}
                                />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="tubetype" className='required'>{messages.labTests.form.tube_type}</label>
                        <select name="tubetype" id="tubetype"
                                value={formData.tube_type}
                                onChange={e => {
                                    document.getElementById('tubetype').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, tube_type: e.target.value })
                                }}
                                disabled={user?.role_id === 1 ? false : true}
                                >
                            <option value={0}>{messages.labTests.form.ref_labs_placeholder}</option>
                            {tubesList.map(tube => <option key={tube.id} value={tube.id}>{tube.name}</option>)}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="blood" className='required'>{messages.labTests.form.tube_number}</label>
                        <input type="number" name="tubeNumber" id="tubeNumber"
                                value={formData.tubes_count}
                                onChange={e => {
                                    document.getElementById('tubeNumber').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, tubes_count: e.target.value })
                                }}
                                disabled={user?.role_id === 1 ? false : true}
                                />
                    </div>
                </div>
                <div className='row' >
                    <div className="col-md-4">
                        <label htmlFor="relatedTest" className='required'>{messages.labTests.form.obligation_type}</label>
                        <select name="relatedTest" id="relatedTest"
                                value={formData.obligation_type}
                                onChange={e => {
                                    document.getElementById('relatedTest').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, obligation_type: e.target.value })
                                }}
                                disabled={user?.role_id === 1 ? false : true}
                                >
                            <option value={0}>{messages.labTests.form.obligation_type_placeholder}</option>
                            {relatedList?.map(test => <option key={test.id} value={test.id}>{test.name}</option>)}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="priceBefore" className='required'>{messages.labTests.form.price_before}</label>
                        <div className="currency_container">
                            <input type="number" name="priceBefore" id="priceBefore"
                                min={0}
                                placeholder={messages.labTests.form.price_before_placeholder}
                                value={formData.price}
                                onChange={e => {
                                    document.getElementById('priceBefore').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, price: e.target.value })
                                }} 
                                disabled={user?.role_id === 1 ? false : true}    
                                /><span>{messages.labTests.currency}</span></div>
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="priceAfter" className='required'>{messages.labTests.form.price_after}</label>
                        <div className="currency_container">
                            <input type="number" name="priceAfter" id="priceAfter"
                                min={0}
                                placeholder={messages.labTests.form.price_after_placeholder}
                                value={formData.price_after_discount}
                                onChange={e => {
                                    document.getElementById('priceAfter').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, price_after_discount: e.target.value })
                                }}
                                disabled={user?.role_id === 1 ? false : true}
                                /><span>{messages.labTests.currency}</span></div>
                    </div>
                </div>
                <div className='row' >
                    <div className="col-md-6">
                        <div className='result_due_days'>
                            <label htmlFor='result_due_days'>{messages.labTests.result_due_days}</label>
                            <input type="number" name="result_due_days" id="result_due_days"
                                min={0}
                                value={formData.result_due_days}
                                onChange={e => {
                                    document.getElementById('result_due_days').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, result_due_days: e.target.value })
                                }
                                }
                                disabled={user?.role_id === 1 ? false : true}
                                />
                            <span>{messages.labTests.result_due_days_label}</span>
                        </div>
                    </div>
                    <div className="col-md-6">
                        
                    </div>
                </div>
                <h3 className='shipping_title'>{messages.shipping.shipping_title}</h3>
                
                {
                    formData.lab_test_shipping_locations?.map((location, index) => (
                        <>
                        {formData?.lab_test_shipping_locations?.length > 1 && index === 0 && <label className='shipping_journey'>{messages.shipping.first_journey}</label>}
                        {formData?.lab_test_shipping_locations?.length > 1 && index === 1 && <label className='shipping_journey'>{messages.shipping.second_journey}</label>}
                        <div className='row' >
                            <div className="col-md-4">
                                <label htmlFor="shipping_company" className='required'>{messages.labTests.form.shipping_company}</label>
                                <select name="shipping_company" id="shipping_company"
                                        value={location.shipping_company}
                                        onChange={e => {
                                            document.getElementById('shipping_company').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData(prevForm => {
                                                return {
                                                    ...prevForm,
                                                    lab_test_shipping_locations: prevForm.lab_test_shipping_locations.map((loc, i) => {
                                                        if(i === index) {
                                                            return {
                                                                ...loc,
                                                                shipping_company: e.target.value
                                                            }
                                                        }
                                                        return loc;
                                                    })
                                                }
                                            })
                                        }}
                                        disabled={user?.role_id === 1 ? false : true}
                                        >
                                    <option value={0}>{messages.labTests.form.shipping_company_placeholder}</option>
                                    {shippingCompanies?.map(company => <option key={company.id} value={company.id}>{company.name}</option>)}
                                </select>
                            </div>
                            <div className="col-md-4">
                            </div>
                            <div className="col-md-4">
                            </div>
                        </div>
                        <div className='row' >
                            <div className="col-md-4">
                                <label htmlFor={`lab_test_shipping_locations${index}_from`} className='required'>{messages.shipping.shipping_destination_from}</label>
                                <select name={`lab_test_shipping_locations${index}_from`} id={`lab_test_shipping_locations${index}_from`}
                                        value={formData.lab_test_shipping_locations[index].from}
                                        onChange={e => {
                                            document.getElementById(`lab_test_shipping_locations${index}_from`).style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData((prevForm) => {
                                                return {
                                                    ...prevForm,
                                                    lab_test_shipping_locations: prevForm.lab_test_shipping_locations.map((item, i) => {
                                                        if (i === index) {
                                                            return { ...item, from: parseInt(e.target.value) }
                                                        } else {
                                                            return item
                                                        }
                                                    })
                                                }
                                            })

                                        }}
                                        disabled={user?.role_id === 1 ? false : true}
                                        >
                                    <option value={0}>{messages.shipping.shipping_destination_from_placeholder}</option>
                                    {shippingLocations?.map(location => <option key={location.id} value={location.id}>{location.name}</option>)}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor={`lab_test_shipping_locations${index}_to`} className='required'>{messages.shipping.shipping_destination_to}</label>
                                <select name={`lab_test_shipping_locations${index}_to`} id={`lab_test_shipping_locations${index}_to`}
                                        value={formData.lab_test_shipping_locations[index].to}
                                        onChange={e => {
                                            document.getElementById(`lab_test_shipping_locations${index}_to`).style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData((prevForm) => {
                                                return {
                                                    ...prevForm,
                                                    lab_test_shipping_locations: prevForm.lab_test_shipping_locations.map((item, i) => {
                                                        if (i === index) {
                                                            return { ...item, to: parseInt(e.target.value) }
                                                        } else {
                                                            return item
                                                        }
                                                    })
                                                }
                                            })
                                        }}
                                        disabled={user?.role_id === 1 ? false : true}
                                        >
                                    <option value={0}>{messages.shipping.shipping_destination_to_placeholder}</option>
                                    {shippingLocations?.map(location => <option key={location.id} value={location.id}>{location.name}</option>)}
                                </select>
                            </div>
                            <div className="col-md-4 labtest_shipping_location_add_container">
                                {index === 0 && formData.lab_test_shipping_locations?.length === 1 && location.to !== 3 ? <div className='labtest_shipping_location_add'
                                                    style={{ cursor: formData.lab_test_shipping_locations.length === 1 ? 'pointer' : 'not-allowed' }}
                                                    onClick={() => {
                                                        if (formData.lab_test_shipping_locations.length < 2) {
                                                            setFormData((prevForm) => {
                                                                return {
                                                                    ...prevForm,
                                                                    lab_test_shipping_locations: [...prevForm.lab_test_shipping_locations, { from: 0, to: 0 }]
                                                                }
                                                            })
                                                        }
                                                    }}>
                                    <AddCircleOutlineIcon />
                                </div> : index === 1 &&
                                <CancelOutlinedIcon className='labtest_shipping_location_remove' onClick={() => {
                                    setFormData((prevForm) => {
                                        return {
                                            ...prevForm,
                                            lab_test_shipping_locations: prevForm.lab_test_shipping_locations.filter((item, i) => i !== index)
                                        }
                                    })
                                }} />
                                }
                            </div>
                        </div>
                        </>
                    ))
                }
                
                { 
                    user?.role_id === 1 ? (
                        <div className='form-footer'>
                            <p>&nbsp;{feedback}</p>
                            <div className="actions">
                                <button type="button" className="myBtn" onClick={(e) => handleSave(e)}>{messages.users.form.btn_save}</button>
                                <button type="button" className="myBtn cancel" onClick={e => {
                                    handleCancel(e);
                                }}>{messages.users.form.btn_cancel}</button>
                            </div>
                        </div>
                    ) : null
                }
            </form>
            <ConfirmDialog show={cancelConfirmation} 
                     onCancel={() => setCancelConfirmation(false)}
                     onConfirm={() => {
                        setCancelConfirmation(false);
                        clear();
                        history.push('/lab-tests');
                     }}
                     icon={null}
                     content={messages.warningMsgs.warning_close_window}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
        </div>
    );
}

export default injectIntl(LabForm);